var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefrigerator = function SvgRefrigerator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 19,
    x: 2.5,
    y: 0.5,
    stroke: "currentColor",
    rx: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 1,
    x: 2,
    y: 10,
    fill: "currentColor",
    rx: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 1,
    x: 6,
    y: 4,
    fill: "currentColor",
    rx: 0.5,
    transform: "rotate(90 6 4)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 1,
    x: 6,
    y: 13.5,
    fill: "currentColor",
    rx: 0.5,
    transform: "rotate(90 6 13.5)"
  })));
};
export default SvgRefrigerator;